<template>
  <div>
    <div class="form-group">
      <label class="lg">{{ __('Token Público') }}</label>
      <input
        id="public-token"
        type="text"
        :value="token"
        class="form-control"
        readonly
        disabled
      >
      <img
        v-if="token"
        class="icon-files"
        src="/build/icons/files.svg"
        @click="selectText('public-token')" 
      />
    </div>
    <div class="form-group mb-0">
      <PassportPersonalAccessTokens />
    </div>
  </div>
</template>

<script>
export default {

  data () {
    return {
      token: null,
    };
  },

  mounted () {
    this.getToken();
  },

  methods: {
    getToken () {
      this.$http.get('/settings/token')
        .then((response) => {
          this.token = response.data;
        });
    },

    async selectText(id) {
      const tokenInput = document.getElementById(id);
      const token = tokenInput.value;

      try {
        await navigator.clipboard.writeText(token);
        Alert.success(this.__('Token copiado'));
      } catch (err) {
        Alert.error(this.__('Erro ao copiar o token'));
      }
    },
  }
};
</script>

<style scoped>

.form-group {
  position: relative;
  margin-bottom: 40px;
}

.form-group .icon-files {
  position: absolute;
  top: 50%;
  transform: translateY(50%);
  right: 2.5%;
  cursor: pointer;
}

.form-control {
  border-radius: 8px;
  border: 1px solid #D1D1D1;
  background: rgba(226, 232, 240, 0.40);
}
</style>
